import { render } from "./FooterLC.vue?vue&type=template&id=ca48404a&scoped=true"
import script from "./FooterLC.vue?vue&type=script&lang=js"
export * from "./FooterLC.vue?vue&type=script&lang=js"

import "./FooterLC.vue?vue&type=style&index=0&id=ca48404a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca48404a"]])

export default __exports__